import {sourceActionTypes} from '../_constants';

export function order(state = {}, action) {
  switch (action.type) {

    // get new source order request
    case sourceActionTypes.ORDER_SOURCE_REQUEST:
      return {
        ...state,
        urlVerified: true,
        isOrdering: true,
      };

    // get new source order success
    case sourceActionTypes.ORDER_SOURCE_SUCCESS:
      return {
        source: action.source
      };

      // get new source order failure
    case sourceActionTypes.ORDER_SOURCE_FAILURE:
      return {
        isVerifying: false,
        urlVerified: false,
        error: action.error
      };

      // get new source link validate failure
    case sourceActionTypes.VALIDATE_SOURCE_REQUEST:
      return {
        isVerifying: true
      };

    case sourceActionTypes.VALIDATE_SOURCE_SUCCESS:
      return {
        urlVerified: true,
        source: action.source
      };

    case sourceActionTypes.VALIDATE_SOURCE_FAILURE:
      return {
        urlVerified: false,
        error: action.error
      };

    case sourceActionTypes.ORDER_SOURCE_RESET:
      return {};

    default:
      return state
  }
}